import React from 'react'
import { useState } from "react";
import { SlideshowLightbox } from "lightbox.js-react";
import "lightbox.js-react/dist/index.css";

const Sportweek = () => {
  const [isOpen, setIsOpen] = useState(false);

  const Sportweek_image = [
    {
        src: require("../../../src/images/sportweek/sportweek.1.jpg"),
    },
    {
        src: require("../../../src/images/sportweek/spportweek.2.jpg"),
    },   
    {
        src: require("../../../src/images/sportweek/spportweek.3.jpg"),
    },   
    {
        src: require("../../../src/images/sportweek/spportweek.4.jpg"),
    },   
    {
        src: require("../../../src/images/sportweek/spportweek.5.jpg"),
    }
]

  return (
    <div>
      <div className="dlab-img-effect on rotate no-hover">
        <div
          onClick={() => {
            setIsOpen(true);
          }}
        >
          <img
            alt="Image with object-fit: cover"
            style={{
              width: "370px",
              height: "250px",
              objectFit: "cover",
            }}
            src={require("../../../src/images/sportweek/sportweek.1.jpg")}
          />
        </div>
        <div className="dlab-info-has p-a20 no-hover ">
          <div className="dlab-post-title">
            <h5 className="post-title" style={{color: "black", backgroundColor: "white", padding: "5px"}}>Sport Week Plasma Induction 2019</h5>
          </div>
        </div>
      </div>
      <SlideshowLightbox
        theme="lightbox"
        images={Sportweek_image}
        showThumbnails={true}
        open={isOpen}
        lightboxIdentifier="lbox1"
        onClose={() => {
          setIsOpen(false);
        }}
      ></SlideshowLightbox>
    </div>
  )
}

export default Sportweek